import React from "react";
import PropTypes from "prop-types";
import { AssigneesContainer } from "../components";
import { Assignee, assigneeVariants, getRandomColor } from "@td/ui";
import { MAX_PRESENTED_ASSIGNEES, assigneeColors } from "../constants";

const Assignees = React.memo(({ assignees = [] }) => (
  <React.Fragment>
    {assignees.length === 1 && (
      <Assignee
        {...assignees[0]}
        variant={assigneeVariants.TEXT}
      />
    )}

    {assignees.length > 1 && assignees.length <= MAX_PRESENTED_ASSIGNEES && (
      <AssigneesContainer>
        {assignees.map((assignee, index) => (
          <Assignee
            key={index}
            {...assignee}
            variant={assigneeVariants.ICON}
            color={getRandomColor(assignee["firstAndLastName"], assigneeColors)}
          />
        ))}
      </AssigneesContainer>
    )}

    {assignees.length > MAX_PRESENTED_ASSIGNEES && (
      <React.Fragment>
        {assignees.slice(0, 2).map((assignee, index) =>
          <Assignee
            key={index}
            {...assignee}
            variant={assigneeVariants.TEXT}
          />
        )}
        <p data-testid="assignees-remaining-count">
          ... +{assignees.length - 2}
        </p>
      </React.Fragment>
    )}
  </React.Fragment>
));

Assignees.propTypes = {
  assignees: PropTypes.array.isRequired,
};

export default Assignees;
